<template>
    <div id="brands-index-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Library Requests</h1>

                <div class="table-header" style="margin-bottom:20px;">
                    <div class="table-header__tabs"></div>
                </div>

                <DataTable class="brands-data-table"
                           :dataUrl="dataUrl"
                           :displayId="false"
                           :key="tableRefreshKey"
                           :dataFormatter="formatData"
                           :predefinedFilters="filtersData"
                           @actionTriggered="actionTriggered">

                    <template v-slot:empty>
                        No records found
                    </template>
                </DataTable>
            </section>
        </div>
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'
const endpoint = process.env.VUE_APP_API_BASE + '/requests'
import axios from 'axios'

export default {
    name: 'RequestsIndex',
    components: {
        DataTable
    },
    data: function() {
        return {
            //users: [],
            dataUrl: endpoint,
            tableRefreshKey: null,

            filtersData: {
                "status": this.getStatusFromUrl()
            }
        }
    },
    methods: {
        getStatusFromUrl() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            return urlParams.getAll('status')
        },
        formatData(data) {
            const newData = []
            for (let obj of data) {
                const newObj = {}
                for (let key in obj) {
                    const ignore = ['__v']
                    if (ignore.includes(key)) {
                        continue
                    }
                    else if (key === 'user') {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'object',
                            'hyper_label': obj[key].name
                        }
                    }
                    else if (key === 'library') {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'object',
                            'hyper_label': obj[key].name
                        }
                    }
                    else if (key.includes('At')) {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'date'
                        }
                    }
                    else {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'text'
                        }
                    }
                }

                const actions = {
                    'approve': `<i class="approve-action" title="Approve Request">Approve</i>`,
                    'reject': `<i class="reject-action" title="Reject Request">Reject</i>`
                }

                if (newObj.status?.value === 'PENDING') {
                    newObj['actions'] = {
                        'label': '',
                        'value': actions,
                        'display_type': 'actions'
                    }
                }
                else {
                    newObj['actions'] = {
                        'label': '',
                        'value': '',
                        'display_type': 'actions'
                    }
                }

                //const newObjOrdered = Object.assign({'image': ''}, newObj)
                newData.push(newObj)
            }
            return newData
        },
        actionTriggered(actionKey, identifier) {
            if (!identifier) {
                alert('Error occurred #89-2')
            }
            else if (actionKey == 'approve') {
                if (confirm('Are you sure you want to APPROVE this library?')) {
                    axios.post(endpoint + '/' + identifier + '/approve')
                        .then(response => {
                            if (response.data.success === true) {
                                this.tableRefreshKey = Date.now()
                            }
                            else {
                                alert('Error occurred')
                                console.log(response.data.data)
                            }
                        })
                        .catch(error => {
                            alert('Error occurred while updating')
                            console.log(error)
                        })
                }
                //this.$router.push('/brands/' + identifier)
            }
            else if (actionKey == 'reject') {
                if (confirm('Are you sure you want to REJECT this library?')) {
                    axios.post(endpoint + '/' + identifier + '/reject')
                        .then(response => {
                            if (response.data.success === true) {
                                this.tableRefreshKey = Date.now()
                            }
                            else {
                                alert('Error occurred')
                                console.log(response.data.data)
                            }
                        })
                        .catch(error => {
                            alert('Error occurred while updating')
                            console.log(error)
                        })
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
